export function isTelegramWebApp() {
  return typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp;
}

export function getTelegramInitDataEncoded() {
  if (!isTelegramWebApp()) {
    return '';
  }
  const raw = window.Telegram.WebApp.initData || '';
  if (!raw) {
    return '';
  }
  return btoa(unescape(encodeURIComponent(raw)));
}

export function initTelegramUi() {
  if (!isTelegramWebApp()) {
    return;
  }
  const wa = window.Telegram.WebApp;
  wa.ready();
  wa.expand();
  if (wa.setHeaderColor) {
    wa.setHeaderColor('#070708');
  }
  if (wa.setBackgroundColor) {
    wa.setBackgroundColor('#070708');
  }
}



// WEBPACK FOOTER //
// ./src/utils/telegram.js